import React, { useState } from "react";
import { Badge, DefaultButton } from "../../../../../UI toolkit/Button/Button";
import { Modal } from "../../../../../UI toolkit/Modal/Modal";
import { H1, H5, H6, P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_left_icon from "../../../../../assets/images/ic-left-arrow.svg";
import { connect } from "react-redux";

import {
  capitalizeFirstLetter,
  formatLargeNumber,
} from "../../../../../utils/specialFunctions";
import { P2PModalStyle } from "./UserP2P.styled";

const UserP2POrderModal = ({
  width,
  border,
  closeModalCallback,
  order,
  user,
}) => {
  return (
    <div>
      <Modal width={width} border={border} callback={closeModalCallback}>
        {order ? (
          <P2PModalStyle>
            <div className="-mx-8">
              <div className="flex items-center justify-between px-6 py-3 border-bottom bg-white">
                <div className="flex items-center">
                  <div>
                    <img
                      src={
                        order.ad.action.toLowerCase() === "buy"
                          ? ic_sent_icon
                          : order.action.toLowerCase() === "sell"
                          ? ic_left_icon
                          : ""
                      }
                      alt="img"
                    />
                  </div>
                  &nbsp;
                  <div>
                    <H6
                      color={"#112E46"}
                      className="text-center"
                      fontWeight="700"
                    >
                      {order.ad.action === "buy"
                        ? "Buy Order"
                        : order.ad.action === "sell"
                        ? "Sell Order"
                        : null}
                    </H6>
                  </div>
                </div>

                <div className="">
                  <Badge
                    color={
                      order.status === "cancelled"
                        ? "#337138"
                        : order.status === "failed"
                        ? "#337138"
                        : order.status === "pending"
                        ? "#606060"
                        : order.status === "active"
                        ? "#531423"
                        : ""
                    }
                    bg={
                      order.status === "cancelled"
                        ? "#FFDCE5"
                        : order.status === "failed"
                        ? "#FFDCE5"
                        : order.status === "pending"
                        ? "#FFEAB6"
                        : order.status === "active"
                        ? "#D1F7C4"
                        : "#337138"
                    }
                  >
                    {order.status}
                  </Badge>
                </div>
              </div>
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      USER
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <div className="mb-2">
                    <P fontSize="16px" color={"#374072"} fontWeight="500">
                      {`${user.firstName} ${user.lastName}`}
                    </P>
                  </div>

                  <div className="">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {user.email}
                    </P>
                  </div>

                  <div className="">
                    <P fontSize="13px" color={"#848A8E"} fontWeight="500">
                      {order?.p2p_profile?.username}
                    </P>
                  </div>
                </div>
              </div>
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      MERCHANT
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <div className="mb-2">
                    <P fontSize="16px" color={"#374072"} fontWeight="500">
                      {`${user.firstName} ${user.lastName}`}
                    </P>
                  </div>

                  <div className="">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {user.email}
                    </P>
                  </div>

                  <div className="">
                    <P fontSize="13px" color={"#848A8E"} fontWeight="500">
                      {order?.p2p_profile?.username}
                    </P>
                  </div>
                </div>
              </div>

              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      BUY RATE
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <P fontSize="16px" color={"#4B4F52"} fontWeight="500">
                    NGN
                    {Number(order.price).toFixed(2).toLocaleString()}
                    /USDT
                  </P>
                </div>
              </div>
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      AMOUNT
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <P fontSize="16px" color={"#4B4F52"} fontWeight="500">
                    {order.action === "sell"
                      ? order?.ad?.source_currency
                      : order?.ad?.action === "buy"
                      ? order?.ad?.destination_currency
                      : ""}
                    {Number(order?.quantity).toFixed(2).toLocaleString()}
                  </P>
                </div>
              </div>

              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      id
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <div className="mb-1">
                    <P fontSize="16px" color={"#374072"} fontWeight="700">
                      {order.id}
                    </P>
                  </div>

                  <div className="my-1">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {new Date(order.created_at).toDateString()}
                    </P>
                  </div>

                  <div className="mt-1">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {new Date(order.created_at).toLocaleTimeString()}
                    </P>
                  </div>
                </div>
              </div>
            </div>
          </P2PModalStyle>
        ) : (
          <P fontSize="13px" color={"#374072"} fontWeight="500">
            Loading.....
          </P>
        )}
      </Modal>
    </div>
  );
};

// Redux store mapstatetoprops and mapdispatchtoprops
const mapStateToProps = (state) => {
  return {
    loading: state.verification.loading,
    error: state.verification.error,
  };
};

// Link Actions to components
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(UserP2POrderModal);
